import { Injectable } from '@angular/core';
import { HttpClient } from "@angular/common/http";
import { map, Observable } from "rxjs";
import { CommonWebService, UserHttpService } from ".";
import { HttpResponse, Faqs } from "../interfaces";
@Injectable({
  providedIn: 'root'
})
export class FaqsService {

  constructor(private http: HttpClient, private commmonService: CommonWebService, private userSessionService: UserHttpService) {}

  public listFaqs():Observable<HttpResponse<Faqs[]>>{
    let formData = new FormData();
        formData.append('user_id', this.userSessionService.getUserInfo.user_id); 
        formData.append('customer_id', this.userSessionService.getUserInfo.usr_customer_track_id); 
        formData.append('usr_role_track_id', this.userSessionService.getUserInfo.usr_role_track_id);
        formData.append('token', this.userSessionService.userToken); 
        return this.http.post<HttpResponse<Faqs[]>>('faq/faqList', formData);
  }
}
